import React from 'react';
const NotificationHub = React.lazy(() => import('./NotificationHub'));

const NotificationHubLoader = ({ userId }) => (
  <React.Suspense fallback={null}>
    <NotificationHub userId={userId} />
  </React.Suspense>
);

export default NotificationHubLoader;
